<mat-accordion>
  <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header [expandedHeight]="'50px'" [collapsedHeight]="'50px'">
          <mat-panel-title id="accAccountCodeMaster">
              <div class="d-flex justify-content-between eip-pt-10 eip-pb-10">
                  <div class="title-container d-flex align-items-center">
                      <mat-label>Change Control Note</mat-label>
                  </div>
                  <div class="acc-icon-container align-items-center view-page-wrap-icons d-flex eip-mr-0">
                      <i class="fa fa-print" title="Print" *ngIf="canPrint" aria-hidden="true" (click)="$event.stopPropagation();printCCN()"></i>
                      <i class="fa fa-pencil" title="Edit" *ngIf="canEdit" aria-hidden="true" (click)="$event.stopPropagation();editCCN()"></i>
                      <i class="fa fa-ban" title="Reject" *ngIf="canApprove" aria-hidden="true" (click)="$event.stopPropagation();approveCCN(false)"></i>
                      <i class="fa fa-check" title="Approve" *ngIf="canApprove" aria-hidden="true" (click)="$event.stopPropagation();approveCCN(true)"></i>
                      <i class="fa fa-check" title="Publish" *ngIf="canPublish" aria-hidden="true" (click)="$event.stopPropagation();publishCCN()"></i>
                  </div>
              </div>
          </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row eip-mt-20">
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div class="view-info eip-mb-20">
                  <p class="view-label">Project Code / Name</p>
                  <p class="view-data" id="lblisConfidential">
                      {{project}}
                  </p>
              </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div class="view-info eip-mb-20">
                  <p class="view-label">Initiated By</p>
                  <p class="view-data">{{ccn.originator}}
                  </p>
              </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div class="view-info eip-mb-20">
                  <p class="view-label">Discipline</p>
                  <p class="view-data" id="lblwarehouse">
                      {{discipline}}
                  </p>
              </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div class="view-info eip-mb-20">
                  <p class="view-label">Approvers</p>
                  <p class="view-data"> {{approvers}}
                  </p>
              </div>
          </div>
      </div>
      <div class="row eip-mt-20">
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div class="view-info eip-mb-20">
                  <p class="view-label">Title for Change Control</p>
                  <p class="view-data"> {{ccn.ccnTitle}} </p>
              </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div class="view-info eip-mb-20">
                  <p class="view-label">Description Reason for Change</p>
                  <p class="view-data"> {{ccn.ccnDescription}} </p>
              </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div class="view-info eip-mb-20">
                  <p class="view-label">Reference Drawing / Documents</p>
                  <p class="view-data"> {{ccn.ccnReference}} </p>
              </div>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div class="view-info eip-mb-20">
                  <p class="view-label">Action</p>
                  <p class="view-data"> {{ccn.ccnAction}} </p>
              </div>
          </div>
      </div>
      <div class="eip-mt-20" [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
          <kendo-grid [kendoGridBinding]="MHList" [reorderable]="true" [sortable]="true" [resizable]="true" [filterable]="false" [pageable]="false">
              <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                      {{rowIndex+1}}
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Discipline" field="dedDescription" [width]="70">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.dedDescription}}" eipTooltipPosition="auto">{{dataItem.dedDescription}} </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Name" field="memberName" [width]="170">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.memberName}}" eipTooltipPosition="auto">{{dataItem.memberName}} </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Status" field="ccnStatusDesc" [width]="80">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.ccnStatusDesc}}" eipTooltipPosition="auto">{{dataItem.ccnStatusDesc}} </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Man Hours" field="manHour" [width]="100">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.manHour}}" eipTooltipPosition="auto">{{dataItem.manHour}} </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="No of Drawings" field="noOfDoc" [width]="170">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.noOfDoc}}" eipTooltipPosition="auto">{{dataItem.noOfDoc}} </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Remarks" field="ccnRemarks" [width]="170">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.ccnRemarks}}" eipTooltipPosition="auto">{{dataItem.ccnRemarks}} </span>
                  </ng-template>
              </kendo-grid-column>
          </kendo-grid>
      </div>
  </mat-expansion-panel>
</mat-accordion>